import { ref } from 'vue'
import { useCookies } from '@vueuse/integrations/useCookies.esm.js' // proste @vueuse/integrations/useCookies padá!!!
const cookies = useCookies(['locale'])

// simple wrapper over the useCookies - for default values and maybe another implementation with another package ... ?
export const $cookies = {
  get (key) {
    return cookies.get(key)
  },
  set (key, value,) {
   
    let expires = (new Date(Date.now()+ 86400*1000*365)) // 1 year by default
    let defaultOptions = {
      'path': '/',
      'expires': expires
    }

    cookies.set(key, value, defaultOptions)
  },
  remove (key) {
    cookies.remove(key)
  },
}

const values = {}

const getItem = (key, defaultValue = null) => {
  let value = $cookies.get(key)
  if (!value) {
    return defaultValue
  }
  try {
    return JSON.parse(value)
  } catch (error) {
    return value
  }
}

export const useStorageCookie = (key, defaultValue = null) => {
  if (!values[key]) {
    values[key] = ref(getItem(key, defaultValue))
  }

  const value = values[key]

  const setItem = () => {
    return newValue => {
      value.value = newValue
      $cookies.set(key, JSON.stringify(newValue), Infinity)
    }
  }
  return [value, setItem()]
}
